import './reviews.component.scss'

import $ from 'jquery'

import 'swiper/css'
import 'swiper/css/autoplay'
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

$(document).ready(function () {

  const stars = {
    template: function (size = 24) {
      return `
                <div class="review-result__stars-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#999999" d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="24" viewBox="0 0 ${size} 24">
                        <path fill="#fec212" d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
                    </svg>
                </div>
            `;
    },
    init: function () {
      $('.review-result__stars').each(function () {
        const $el = $(this);
        $el.html('');
        const rate = parseFloat($(this).data('rate'));
        const rateEach = parseInt(rate);
        const after = parseInt(rate.toString().split('.')[1]);
        for (let i = 0; i < rateEach; i++) {
          $el.append(stars.template());
        }
        if (after) {
          $el.append(stars.template(24 * (after / 10)));
        }
        if (rate + 0.99 < 5) {
          const iterations = after ? 5 - rateEach - 1 : 5 - rateEach;
          for (let i = 0; i < iterations; i++) {
            $el.append(stars.template(0));
          }
        }
      });
    }
  };

  stars.init();
  new Swiper('.reviews__slider .swiper-container', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      prevEl: '.reviews__slider-prev',
      nextEl: '.reviews__slider-next'
    }
  });
});